var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"spaceship"},[_c('img',{attrs:{"src":"/images/mothership_logo_256.webp"}})])
}]

export { render, staticRenderFns }